const DashboardService = {
    getDataAnalytics (projectId, range, interval = '1h') {
        return window.$http.get(
            `/projects/${projectId}/analytics/`,
            {
                params: {
                    from: range.from,
                    to: range.to,
                    interval: interval
                }
            }
        )
    },
    getApiAnalytics (projectId, api, range, interval) {
        return window.$http.get(
            `/projects/${projectId}/analytics/${api}/`,
            {
                params: {
                    from: range.from,
                    to: range.to,
                    interval: interval
                }
            }
        )
    }
}

export default DashboardService
